<!-- 故障报修 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('报修人名称')">
              <a-input :placeholder="$t('请输入报修人名称')" v-model="queryParam.repairName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <a-button type="primary" icon="download" @click="handleExportXls('construction_detail')">{{ $t('导出') }}</a-button>
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{ $t('批量操作') }} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{ $t('已选择 {count} 项', { count: selectedRowKeys.length }) }}
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="repairState" slot-scope="text,record">
          <a-tag color="#c9c9c9" v-if="record.repairState==0">{{ $t('待指派') }}</a-tag>
          <a-tag color="#108ee9" v-if="record.repairState==1">{{ $t('报修中') }}</a-tag>
          <a-tag color="#87d068" v-if="record.repairState==2">{{ $t('等待评价') }}</a-tag>
          <a-tag color="#f50" v-if="record.repairState==3">{{ $t('结束') }}</a-tag>
        </template>
        <span slot="action" slot-scope="text, record">
          <template v-if="record.repairState==0">
            <a @click="handleAssign(record)">{{ $t('指派') }}</a>
            <a-divider type="vertical" />
          </template>
          <template v-if="record.repairState==1">
            <a @click="handleAssign(record)">{{ $t('处理') }}</a>
            <a-divider type="vertical" />
          </template>
          <template v-if="record.repairState==3">
            <a @click="handleEvaluate(record)">{{ $t('查看评价') }}</a>
            <a-divider type="vertical" />
          </template>
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record,'detail')">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm="() => handleDelete(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <assignModal ref="assignForm" @ok="modalFormOk"></assignModal>
    <modal ref="modalForm"></modal>
    <rateModal ref="rateForm"></rateModal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import assignModal from './assignModal'
  import Modal from './modal'
  import rateModal from './rateModal'
  import { postAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';

  export default {
    name: 'ConstructionDetailList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      assignModal,
      Modal,
      rateModal
    },
    data () {
      return {
        url: {
          list: "/jeecg-engineering/engineering/meterRepair/list",
          delete: "/jeecg-engineering/engineering/meterRepair/delete",
          deleteBatch: "/jeecg-engineering/engineering/meterRepair/deleteBatch",
          // exportXlsUrl: "/jeecg-engineering/engineering/installationDetail/exportXls",
          // importExcelUrl: "jeecg-engineering/engineering/installationDetail/importExcel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {},
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // 表头
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('状态'),
            align:"center",
            dataIndex: 'repairState',
            scopedSlots: { customRender: 'repairState' }
          },
          {
            title: this.$t('报修人名称'),
            align:"center",
            dataIndex: 'repairName'
          },
          {
            title: this.$t('报修人电话'),
            align:"center",
            dataIndex: 'repairPhone',
          },
          {
            title: this.$t('精确地址'),
            align:"center",
            dataIndex: 'repairAddress',
          },
          {
            title: this.$t('情况描述'),
            align:"center",
            dataIndex: 'repairDescription',
          },
          {
            title: this.$t('报修时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      // 指派
      handleAssign(row){
        this.$nextTick(()=>{
          this.$refs.assignForm.init(row);
        })
      },
      handleDetail(row){
        this.$nextTick(()=>{
          this.$refs.modalForm.init(row);
        });
      },
      // 查看评价
      handleEvaluate(row){
        this.$nextTick(()=>{
          this.$refs.rateForm.init(row);
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>